import React from 'react';

// Servicios
import { removeCookie } from '../services/cookieService';

export default class Login extends React.PureComponent {

  componentDidMount() {
    // Remove cookies
    removeCookie("SubCompanyId");
    removeCookie("TypeUser");
    removeCookie("SalesPerson");
    removeCookie("Company");
    removeCookie("CompanyId");
    removeCookie("phone");
    removeCookie("warehouse");
    removeCookie("website");
    removeCookie("address");
    removeCookie("fullName");
    removeCookie("DocumentsLogo");
    removeCookie("CompanyLogo");
    removeCookie("TotalOrders");
    removeCookie('redirectTo');
    removeCookie('apiPrefix');
    removeCookie('sessionAuthToken');
    removeCookie('userName');
    removeCookie('SalesPersonList');
    // Redirect to login
    window.location.href = '/login';
  }

  render() {
    return null;
  }
}
